import { BotBase } from './botBase';

import type { Command, Manager } from '../lib';
import { getRandomItem, makeNextStageCommand, RoundStage } from '../lib';

export class RandomBot extends BotBase {
	public getCommand(game: Manager): Command | null {

		const validCommands = game.getValidActions(this.position);
		const randomCommand = getRandomItem(validCommands);

		switch (game.gameState.roundStage) {
			case RoundStage.TrickEnd:
				return makeNextStageCommand();
			case RoundStage.RoundEnd:
				if (this.autoAdvanceRound) {
					return makeNextStageCommand();
				}

				return randomCommand;
			case RoundStage.Pass:
				return randomCommand;
			case RoundStage.PassEnd:
				if (this.autoAdvanceRound) {
					return makeNextStageCommand();
				}

				break;
			default:
				return randomCommand;
		}

		return null;

	}
}
